var React = require('react');

function ToolsIconMobile (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#005F9E","d":"M0 0h61v61H0z","key":0}),React.createElement("path",{"d":"M44.173 39.289l-11.898-11.97c1.177-3.025.523-6.576-1.96-9.075-2.616-2.631-6.538-3.157-9.675-1.71l5.621 5.655-3.922 3.946-5.752-5.655c-1.57 3.156-.916 7.102 1.7 9.733 2.483 2.499 6.013 3.157 9.02 1.973l11.897 11.97a1.259 1.259 0 0 0 1.83 0l3.008-3.026c.653-.526.653-1.447.13-1.841z","fill":"#FFF","key":1})]));
}

ToolsIconMobile.displayName = "ToolsIconMobile";

ToolsIconMobile.defaultProps = {"width":"61","height":"61"};

module.exports = ToolsIconMobile;

ToolsIconMobile.default = ToolsIconMobile;
